import type { SharedVarsMap } from '@amzn/journeys-common';
import { type FEATURED_BRANDS_TEMPLATES, FEATURED_BRANDS_TEMPLATES_ABBREVIATION, type FeaturedBrandsContent } from '../types';
import { hasProgramAsins } from './hasProgramAsins';

/**
 * Generates a strategy name for featured brands based on provided parameters
 *
 * @param {FEATURED_BRANDS_TEMPLATES} creativeType - The type of creative template
 * @param {FeaturedBrandsContent} content - The content object containing program information
 * @param {SharedVarsMap} sharedVarsMap - Map containing shared variables
 * @param {string|null} brandNameForSlug - Brand name for URL slug, if applicable
 * @param {string} campaignId - Unique campaign identifier
 * @returns {string} Formatted strategy name string
 */
export const getStrategyName = (
  creativeType: FEATURED_BRANDS_TEMPLATES,
  content: FeaturedBrandsContent,
  sharedVarsMap: SharedVarsMap,
  brandNameForSlug: string | null,
  campaignId: string,
): string => {
  const template = FEATURED_BRANDS_TEMPLATES_ABBREVIATION[creativeType as keyof typeof FEATURED_BRANDS_TEMPLATES_ABBREVIATION];
  const asinSuffix = hasProgramAsins(content, sharedVarsMap) ? '-asin' : '';
  const brandSuffix = brandNameForSlug ? `-${brandNameForSlug}` : '';

  return `featured-brands-${template}${asinSuffix}${brandSuffix}-${campaignId}`;
};
